import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter automatiquement les infos utilisateur
api.interceptors.request.use(
  (config) => {
    try {
      const userStr = localStorage.getItem('boaz_user');
      if (userStr) {
        const user = JSON.parse(userStr);
        config.headers['X-User-Info'] = JSON.stringify(user);
        // Ajouter l'email pour filtrage des souscriptions CLIENT
        if (user.email) {
          config.headers['X-User-Email'] = user.email;
        }
      }
    } catch (error) {
      console.warn('Erreur lors de la récupération des infos utilisateur:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;